import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { showConfirmDialog } from "../../Logic/ConfirmDialog/showConfirmDialog";
import {
    Departments,
    GetDepartments,
    GetMailboxes,
    GetMailboxRoles,
    MailboxList,
    MailboxRolesListItemDTO,
} from "../../Logic/EmsAPI/mailboxAccessRequest";
import { RootState } from "../../state/store";
import DropdownWithQuickFind from "../Generic/Form/DropDownWithQuickFind";
import { CreateMailboxAccessRequest, GetUserProfileData, GetUserResponse } from "./tenantApiCall";

function RequestMailboxAccess() {
    const UserInfo = useSelector((state: RootState) => state.UserInformation);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [userProfile, setUserProfile] = useState<GetUserResponse>();
    const [mailboxes, setMailboxes] = useState<Array<MailboxList>>([]);
    const [mailboxRoles, setMailboxRoles] = useState<Array<MailboxRolesListItemDTO>>([]);
    const [departments, setDepartments] = useState<Array<Departments>>([]);
    const [mailboxId, setMailboxId] = useState<number>(0);
    const [roleId, setRoleId] = useState<number>(0);
    const [motivationComment, setMotivationComment] = useState<string>("");

    useEffect(() => {
        (async () => {
            await loadData();
        })();
    }, []);

    async function loadData() {
        const mailboxes_results = GetMailboxes();
        const mailbox_roles_results = GetMailboxRoles();
        const departments_results = GetDepartments();
        const profileResponse = await GetUserProfileData(UserInfo.userID);
        Promise.all([mailboxes_results, mailbox_roles_results, departments_results, profileResponse]).then(results => {
            if (results[0].isOk) {
                setMailboxes(results[0].data?.items!);
            }
            if (results[1].isOk) {
                setMailboxRoles(results[1].data?.items!);
            }
            if (results[2].isOk) {
                setDepartments(results[2].data?.items!);
            }
            if (results[3].isOk && results[3].data) {
                let profile = { email: "", jobTitle: "" };
                if (results[3].data.profile) {
                    profile = JSON.parse(results[3].data.profile);
                } else {
                    profile.email = UserInfo.email ?? "";
                    profile.jobTitle = UserInfo.jobTitle ?? "";
                }
                results[3].data.profile_email = profile.email;
                results[3].data.profile_jobTitle = profile.jobTitle;
                setUserProfile(results[3].data);
            }
            setIsLoading(false);
        });
    }

    function getMissingRequiredFields(): string[] {
        const missing: string[] = [];
        if (UserInfo.userID <= 0) missing.push("User");
        if (mailboxId <= 0) missing.push("Mailbox");
        if (roleId <= 0) missing.push("Role");
        return missing;
    }

    async function submitMailboxAccessRequest() {
        const missingFields = getMissingRequiredFields();
        if (missingFields.length > 0) {
            await showConfirmDialog(`The following fields are required: ${missingFields.join(", ")}`, {
                messageType: "warn",
                showCancel: false,
            });
            return;
        }

        const result = await CreateMailboxAccessRequest({
            UserID: UserInfo.userID,
            MailboxID: mailboxId,
            RoleID: roleId,
            MotivationComment: motivationComment || null,
        });
        if (result.isOk) {
            alert("Mailbox access request submitted successfully.");
            setMailboxId(0);
            setRoleId(0);
            setMotivationComment("");
        } else {
            alert("Failed to submit mailbox access request.");
        }
    }

    return (
        <>
            <div className="header">
                Mailbox Access Request{" "}
                <div style={{ textAlign: "right", float: "right", marginRight: "10px" }}>
                    <button
                        className="g-btn-action"
                        style={{ fontSize: "9pt", textAlign: "right" }}
                        onClick={submitMailboxAccessRequest}
                    >
                        {" "}
                        Submit Request
                    </button>
                </div>
            </div>
            <div style={{ padding: "20px", paddingTop: "13px" }}>
                {isLoading && <div>Loading...</div>}
                {!isLoading && (
                    <>
                        <div className="row">
                            <DropdownWithQuickFind
                                id="mailboxId"
                                label="Mailbox"
                                value={mailboxId === 0 ? "" : mailboxId.toString()}
                                returnFunc={newValue => setMailboxId(Number(newValue))}
                                Valid={true}
                                options={mailboxes.map(item => ({
                                    text: item.name,
                                    value: item.id.toString(),
                                }))}
                            ></DropdownWithQuickFind>
                            <div></div>
                            <DropdownWithQuickFind
                                id="roleId"
                                label="Role"
                                value={roleId === 0 ? "" : roleId.toString()}
                                returnFunc={newValue => setRoleId(Number(newValue))}
                                Valid={true}
                                options={mailboxRoles.map(item => ({ text: item.name, value: item.id.toString() }))}
                            ></DropdownWithQuickFind>
                            <div className="row rowMarginControl">
                                <div className="col-sm-3">
                                    <label className="g-label">Motivation</label>
                                </div>
                                <div className="col-sm-9">
                                    <textarea
                                        className="g-TextArea-default"
                                        value={motivationComment}
                                        onChange={e => setMotivationComment(e.currentTarget.value)}
                                        maxLength={512}
                                    />
                                </div>
                            </div>
                        </div>
                        <br></br>
                    </>
                )}
            </div>
        </>
    );
}
export default RequestMailboxAccess;
